import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@shared/helper_lib/utils"

const bannerVariants = cva(
  "flex w-full items-center justify-between gap-4 rounded-lg p-4 text-sm",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        muted: "bg-muted text-muted-foreground",
        primary: "bg-primary/10 text-primary border border-primary/20",
        destructive:
          "bg-destructive/10 text-destructive border border-destructive/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BannerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof bannerVariants> {}

const Banner = React.forwardRef<HTMLDivElement, BannerProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="banner"
        className={cn(bannerVariants({ variant }), className)}
        {...props}
      />
    )
  }
)
Banner.displayName = "Banner"

export { Banner, bannerVariants }
